import { createTheme } from "@mui/material";
import { palette } from "./palette";
import { typography } from "./typography";

export const theme = createTheme({
    palette: palette,
    typography: typography,
    components: {
        MuiButton: {
            defaultProps: {
                variant: "contained"
            },
            styleOverrides: {
                contained: {
                    background: palette.warning.main,
                    color: palette.common.black,
                    fontWeight: 600,
                    fontFamily: "'Montserrat', serif",
                    fontSize: "1rem",
                    textTransform: "none",
                    padding: "10px 40px",
                    borderRadius: "5px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                }
            }
        }
    }
})
